var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.getErrorDesc)+" "),_c('ul',{staticClass:"pl-0"},_vm._l((_vm.getErrors),function(error,index){return _c('li',{key:index},[_vm._v(_vm._s(_vm.getErrorMessage(error)))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }